module.exports = __webpack_public_path__ + "static/media/Mobile_arquitetura_de_negocio.56e05896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Arqnegicio_conceitos_apllic/Mobile_arquitetura_de_negocio.png
// module id = 110
// module chunks = 0